import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ToastService} from "../../core/notifications/toast-service";
import {EventService} from "../../services/event.service";
import {Scoreboard, SpotfightEvent, UserScore} from "../../core/models/models";

import {UserRankComponent} from "../user-rank/user-rank.component";
import {ScoreboardService} from "../../services/scoreboard.service";
import {ScoreTableComponent} from "../score-table/score-table.component";
import {NgbAccordionModule, NgbCarouselModule} from "@ng-bootstrap/ng-bootstrap";
import {ImageService} from "../../services/image.service";
import {EventAccordionComponent} from "../event-accordion/event-accordion.component";
import {LinkAccountHintComponent} from "../link-account-hint/link-account-hint.component";
import {LEAGUE_LONG_TERM} from "../../core/models/leagues";
import {CompactEventCardComponent} from "../compact-event-card/compact-event-card.component";
import {SpotfightDateFormatPipe} from "../../core/pipes/date-format/spotfight-date-format.pipe";
import {longTermEventStatus} from "../../core/models/event-status";

@Component({
  selector: 'app-user',
  standalone: true,
  imports: [
    UserRankComponent,
    ScoreTableComponent,
    NgbCarouselModule,
    EventAccordionComponent,
    LinkAccountHintComponent,
    CompactEventCardComponent,
    NgbAccordionModule,
    SpotfightDateFormatPipe
],
  templateUrl: './user.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './user.component.scss'
})
export class UserComponent implements OnInit {

  constructor(private eventService: EventService,
              private toastService: ToastService,
              private scoreboardService: ScoreboardService,
              private imageService: ImageService) {
  }

  userScore: UserScore | undefined;
  pastEvents: SpotfightEvent[] | undefined;
  nextEvents: SpotfightEvent[] | undefined;
  longTermEvents: SpotfightEvent[] = [];
  scoreboard: Scoreboard | undefined;
  logoUrl: string | null = null;
  defaultLogoUrl: string = '/assets/sf-logo-top-2024-small.png';

  get openLongTermEvents(): SpotfightEvent[] {
    return this.longTermEvents.filter(event => longTermEventStatus(event) === 'open');
  }

  get runningLongTermEvents(): SpotfightEvent[] {
    return this.longTermEvents.filter(event => longTermEventStatus(event) === 'running');
  }

  get nextLongTermDeadline(): Date | undefined {
    return this.openLongTermEvents
      .map(event => event.deadline)
      .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())[0];
  }

  ngOnInit(): void {
    this.imageService.getBanner()
      .then(response => {
        this.logoUrl = response;
      })
      .catch(err => {
          this.logoUrl = this.defaultLogoUrl;
        }
      );

    this.eventService.getLastEvents()
      .then((events) => {
        this.pastEvents = events;
        this.loadImages(events);
      })
      .catch((error) => console.log(error));
    this.eventService.getNextEvents()
      .then((events) => {
        this.nextEvents = events;
        this.loadImages(events);
      })
      .catch((error) => console.log(error));

    this.eventService.getLiveEventsForLeague(LEAGUE_LONG_TERM)
      .then((events) => {
        this.longTermEvents = events;
        this.loadImages(this.longTermEvents);
      })
      .catch((error) => console.log(error));

    this.scoreboardService.getScoreboardOverall()
      .then((scoreboardOverall) => this.scoreboard = scoreboardOverall)
      .catch(() => this.toastService.showDanger("Scoreboard konnte nicht geladen werden!"))

    this.scoreboardService.getUserScoreOverall()
      .then((userScore) => {
        this.userScore = userScore;
      })
      .catch(() => this.toastService.showDanger("User Score konnte nicht geladen werden!"))
  }

  loadMore() {
    if (this.scoreboard?.last_key == undefined) {
      this.toastService.showDanger("Keine weiteren Einträge vorhanden!")
      return;
    }

    const lastKey = this.scoreboard!.last_key!;

    this.scoreboardService.getScoreboardOverallWithLastKey(lastKey).then(
      (scoreboard) => this.updateScoreboard(scoreboard))
      .catch(() => this.toastService.showDanger("No scoreboards found"));

  }

  private updateScoreboard(scoreboard: Scoreboard) {
    this.scoreboard!.scores = this.scoreboard!.scores.concat(scoreboard.scores);
    this.scoreboard!.last_key = scoreboard.last_key;
  }

  private loadImages(events: SpotfightEvent[]) {
    for (let event of events) {
      if (event.image_uri !== undefined && event.image_uri !== "") {
        this.imageService.getImage(event.image_uri)
          .then((value) => {
            event.image_content = value;
          })
          .catch(() => console.log("Error loading image for event"));
      }
    }
  }
}
